<template>
  <div class="redirect-container">
    <div class="success-msg">
      <div class="text">授权成功，正在返回业务页面...</div>
    </div>
  </div>
</template>

<script>
/**
 * 微信静默授权 - 授权回调页面（URL 跳转方式）
 * 
 * 流程说明：
 * 1. 微信授权完成后回调到本页面，URL 参数包含：
 *    - code: 微信授权码
 *    - from: 业务页面 URL（来自中转站传递的参数）
 * 2. 本页面将 code 附加到业务页面 URL 的 query 参数中
 * 3. 跳转回业务页面，业务页面可以从 URL 中获取 code 
 * 
 * URL 参数：
 * @param {String} code - 微信授权码
 * @param {String} from - 业务页面的完整 URL
 * @param {String} state - 微信返回的 state 参数
 */
export default {
  name: 'WxRedirect',
  
  mounted() {
    this.handleRedirect();
  },
  
  methods: {
    /**
     * 处理微信授权回调
     */
    handleRedirect() {
      const { code, from, state } = this.$route.query;
      
      // 参数校验
      if (!code) {
        console.error('[WxRedirect] 微信授权失败，未获取到 code');
        this.showError('未获取到授权码');
        return;
      }

      if (!from) {
        console.error('[WxRedirect] 缺少 from 参数，无法确定业务页面');
        this.showError('缺少来源页面参数');
        return;
      }

      try {
        // 解析业务页面 URL
        const fromUrl = new URL(from);
        
        // 将 code 添加到业务页面的 query 参数中
        // 注意：不要覆盖业务页面原有的参数
        fromUrl.searchParams.set('wx_code', code);
        
        // 构建最终的跳转 URL
        const targetUrl = fromUrl.toString();
        
        // 跳转回业务页面
        window.location.href = targetUrl;
      } catch (error) {
        console.error('[WxRedirect] 解析 URL 失败:', error);
        this.showError('URL 解析失败');
      }
    },

    /**
     * 显示错误信息
     */
    showError(message) {
      alert(`授权失败: ${message}\n\n请返回业务页面重试`);
    }
  }
}
</script>

<style scoped>
.redirect-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.success-msg {
  text-align: center;
  background: white;
  padding: 40px;
  border-radius: 12px;
}

.text {
  font-size: 16px;
  color: #999;
}
</style>
